import Intro from "@/components/intro";
import { CISCO_CONSTANTS } from "./constants";

const CiscoSdn = () => {
  return <Intro {...CISCO_CONSTANTS} />;
};

export default CiscoSdn;
